// TODO: fixing tsc build. This function was missing from the project and
// is used in features that are not enabled currently.

interface IUser {}

export function getNameNickname(user: IUser): string {
  return '';
}
